import React from "react";
import { connect } from "react-redux";
import TextField from "../../../../Shared/fields/TextField";
import { Button, SelectBox, ValidationGroup } from "devextreme-react";
import { openCloseToast } from "../../../../Global/actions";
import guid from "../../../../../helpers/guid"

import {
  setEditTrabajadoresSN,
  setWorkersUpdate,
  setDataSolicitudAgenda,
  sendAgendamiento,
  setListaEmpleadosTabla,
  setShowHideForm,
  setCleanDataComplain,
  setTipoSolicitud
} from "./actions";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import validaciones from "../../../../../helpers/validaciones";

class EditarTrabajadores extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      // workers: [],
      tipoDocumentos: [
        { Id: 1, Tipo: "Rut" },
        { Id: 2, Tipo: "Pasaporte" },
        { Id: 3, Tipo: "Otro" },
      ],
      isValidRut: null,
      ingresoMailTrabajador: [],
      ingresoRutTrabajador: [],
    };
  }

  componentWillUnmount = () => {
    this.props.dispatch(setEditTrabajadoresSN(false));
  }

  handleChange = (item, i) => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    var arrayRut = [...this.state.ingresoRutTrabajador];
    const { formatoListaEmpleados: workers } = this.props;
    const { value } = item;

    const _split_id = item.element.id.split("_");
    const _element = _split_id[0];
    const _position = _split_id[1];
    switch (_element) {
      case "tipoDocumento": {
        _data.listaEmpleados[_position].tipoDocumento = item.value;
        if(item.value === 1 ){
          let tempRut = _data.listaEmpleados[_position].rutEmpleado
          if (tempRut && tempRut.length >= 8 && tempRut.length <= 12) {
            tempRut = validaciones.formatRut(tempRut, { showDots: true, showHyphen: true });
          }
          const isValid = validaciones.validateRut(tempRut);
          if (!isValid) {
            //const arrayRut = this.state.ingresoRutTrabajador;
            arrayRut.push(Number(_position));
            arrayRut = [...new Set(arrayRut)];
            this.setState({
              ingresoRutTrabajador: arrayRut,
            });
          } else {
            arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
            this.setState({ ingresoRutTrabajador: arrayRut });
          }
          _data.listaEmpleados[_position].rutEmpleado = tempRut;
        }else{
          arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
          this.setState({ ingresoRutTrabajador: arrayRut });
          _data.listaEmpleados[_position].rutEmpleado = validaciones.cleanRut(_data.listaEmpleados[_position].rutEmpleado);
        }
        break;
      }
      case "rutEmpleado": {
        if (_data.listaEmpleados[_position].tipoDocumento === 1) {
          const isValid = validaciones.validateRut(item.value);
          if (item.value && item.value.length >= 8 && item.value.length <= 12 && isValid) {
            item.value = validaciones.formatRut(item.value, { showDots: true, showHyphen: true });
            arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
            this.setState({ ingresoRutTrabajador: arrayRut });
          }else{
            if(item.value){
              arrayRut.push(Number(_position));
              arrayRut = [...new Set(arrayRut)];
              this.setState({
                ingresoRutTrabajador: arrayRut,
              });
            }else{
              this.setState({
                ingresoRutTrabajador: arrayRut ? arrayRut.filter(ee => ee !== Number(_position)) : [],
              });
            }

          }
        }

        _data.listaEmpleados[_position].rutEmpleado = item.value;
        break;
      }
      case "nombreEmpleado": {
        workers[_position].nombreEmpleado = value;
        break;
      }
      case "celularEmpleado": {
        workers[_position].celularEmpleado = value;
        break;
      }
      case "emailEmpleado": {
        const isValid = validaciones.validarEmail(item.value);
        if(isValid){
          const arrayMail = this.state.ingresoMailTrabajador.filter((ee) => ee !== Number(_position));
          this.setState({ ingresoMailTrabajador: arrayMail });
        }else{
          if(item.value){
            var arrayMail = this.state.ingresoMailTrabajador;
            arrayMail.push(Number(_position));
            arrayMail = [... new Set(arrayMail)]
            this.setState({
              ingresoMailTrabajador: arrayMail,
            });
          }else{
            this.setState({
              ingresoMailTrabajador: arrayMail ? arrayMail.filter(ee => ee !== Number(_position)) : [],
            });
          }
        }
        _data.listaEmpleados[_position].emailEmpleado = item.value;
        break;
      }
      default:
    }
    _data.listaEmpleados = [...workers];

    if (!this.props.isWorkersUpdate) { this.props.dispatch(setWorkersUpdate(true)); }

    this.props.dispatch(setDataSolicitudAgenda(_data));
  };
  handleBack = () => {
    this.props.dispatch(setTipoSolicitud({
      Icon: "0", name: "Aprobadas", column: "estadoSolicitud", value: { text: "aprobado", value: 2 },
    }))
    this.props.dispatch(setCleanDataComplain());
    this.props.dispatch(setEditTrabajadoresSN(false));
    this.props.dispatch(setShowHideForm(false));
  };
  saveTrabajadores = (params) => {
    //const result = params.validationGroup.validate();
    //if (result.isValid) {
      const {
        dataSolicitudAgendaSel,
        companyId,
        userData: { RUT },
      } = this.props;
      var data = {};
      data = dataSolicitudAgendaSel;
      data.listaEmpleados = dataSolicitudAgendaSel.listaEmpleados;
      data.baterias = [];
      data.examenesAdicionales = [];
      data.examenesPsicologicos = [];
      data.idSolicitud = dataSolicitudAgendaSel.idSolicitud;

      const _updated = {
        isWorkersUpdate: true,
        isPoolsUpdate: false,
        isExamsUpdate: false,
        isRequestHeaderUpdate: true,
      };
      this.props.dispatch(sendAgendamiento(data, companyId, RUT, 2, _updated));
      this.props.dispatch(setEditTrabajadoresSN(false));
    //} else {
     // this.showToastr("Debe ingresar documento y nombre", "error");
    //}
  };

  removeTrabajador = (e, i, d) => {
    const { formatoListaEmpleados: workers } = this.props;
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const newList = workers.filter((v, x) => x !== i);
    if (!this.props.isWorkersUpdate) this.props.dispatch(setWorkersUpdate(true));
    _data.listaEmpleados = [...newList];
    this.props.dispatch(setDataSolicitudAgenda(_data));
    this.props.dispatch(setListaEmpleadosTabla(newList));
  };

  showToastr = (msg, type) => this.props.dispatch(openCloseToast({
    isToastOpen: true,
    msgToast: msg,
    typeStyle: type,
    displayTime: 5000,
  }));

  renderBoxTrabajadores(worker, i) {
    const ingresoRutTrabajador = this.state.ingresoRutTrabajador;
    const ingresoMailTrabajador = this.state.ingresoMailTrabajador;
    const {
      tipoDocumento,
      rutEmpleado,
      celularEmpleado,
      nombreEmpleado,
      emailEmpleado,
    } = worker;
    const rutValid = (worker.rutEmpleado && ingresoRutTrabajador.find((element) => element === i) !== undefined) ? false : true
    const emailValid = worker.emailEmpleado && ingresoMailTrabajador.find((element) => element === i) !== undefined ? false : true
    return (
      <div className="boxTrabajador" key={`e_${i}`}>
        <div className="row grid-table">
          <div className="grid-table-index">{i + 1}.</div>
          <div>
            <SelectBox
              id={`tipoDocumento_${i}`}
              value={tipoDocumento || 1}
              dataSource={this.state.tipoDocumentos}
              onValueChanged={(val) => this.handleChange(val, i)}
              displayExpr="Tipo"
              valueExpr="Id"
              searchEnabled
              style={{ height: 40 }}
            />
          </div>
          <div >
            <TextField
              id={`rutEmpleado_${i}`}
              onChange={this.handleChange}
              maxLength={50}
              value={rutEmpleado || null}
              max={12}
              key={guid.new()}
              isValid={rutValid}
              validationError={{ message: "RUT Inválido" }}
            />

          </div>
          <div >
            <TextField
              key={guid.new()}
              id={`nombreEmpleado_${i}`}
              onChange={(val) => this.handleChange(val, i)}
              value={nombreEmpleado || null}
              maxLength={100}
              onKeyUp={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^a-zA-Z ]+/, "");
              }}
              onKeyDown={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^a-zA-Z ]+/, "");
              }}
              isValid={rutEmpleado && !nombreEmpleado ? false : true}
              validationError={{ message: "Se requiere nombre" }}
            />
          </div>
          <div>
            <TextField
              id={`celularEmpleado_${i}`}
              maxLength={9}
              onChange={(val) => this.handleChange(val, i)}
              value={celularEmpleado || null}
              onKeyUp={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^0-9]+/, "");
              }}
              onKeyDown={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^0-9]+/, "");
              }}
              skipValidation
            />
          </div>
          <div>
            <TextField
              id={`emailEmpleado_${i}`}
              onChange={this.handleChange}
              value={emailEmpleado || null}
              maxLength={60}
              skipValidation
              key={guid.new()}
              isValid={emailValid}
              validationError={{ message: "Email Inválido" }}
            />
          </div>
          <div >
            <div className="close-button">
              <Button
                icon="close"
                stylingMode="text"
                height={22}
                width={22}
                onClick={(event) => this.removeTrabajador(event, i)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const { formatoListaEmpleados: workers, isLoading } = this.props;
    return (
      <ValidationGroup>
        <div className="col-12">
          {isLoading && <LoadingOverlay />}
          <div className="row">
            <div className="col-12">
              <h4 className="newDenuncia-subtitle">Trabajadores sin nombre</h4>
              <p>
              Ingresa la información de los trabajadores SIN NOMBRE a más tardar el día antes de la atención.
              </p>
            </div>
          </div>
          <div className="col-12 zero ingresoTrabajadores">
            <div className="col-12 listaTabajadores" style={{ padding: 0 }}>
              <div
                className="row zero headers-grid-table-aprobadas"
              >
                <div></div>

                <div >Tipo documento</div>
                <div >N° Documento</div>
                <div >Nombre</div>
                <div >Celular</div>
                <div >Email</div>
                <div />
              </div>
              {workers ? workers.map((w, i) => this.renderBoxTrabajadores(w, i)) : null}

            </div>

            <div
              className="col-12 buttons-next-prev"
              style={{ margin: "7px 0 0 -15px" }}
            >
              <div className="row">
                <div className="col-6">
                  <Button
                    text="Volver"
                    className="back-button"
                    onClick={this.handleBack}
                  />
                </div>
                <div className="col-6" style={{ paddingRight: 0 }}>
                  <Button
                    text="Aceptar"
                    type="success"
                    disabled={(
                      (workers && workers.length &&
                      workers.find(e => e.rutEmpleado && !e.nombreEmpleado) &&
                      !workers.find(e => !e.rutEmpleado && e.nombreEmpleado)
                      ) ||
                      this.state.ingresoRutTrabajador.length ||
                      this.state.ingresoMailTrabajador.length
                      ) ? true : false}
                    className="next-button"
                    onClick={this.saveTrabajadores}
                    style={{ float: "right" }}
                    useSubmitBehavior
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ValidationGroup>
    );
  }
}
const mapStateToProps = (state) => ({
  isLoading: state.solicitudesAgendaSel.isLoading,
  dataSolicitudAgendaSel: state.solicitudesAgendaSel.dataSolicitudAgendaSel,
  isWorkersUpdate: state.solicitudesAgendaSel.isWorkersUpdate,
  companyId: state.global.companyId,
  userData: state.global.userData,
  formatoListaEmpleados: state.solicitudesAgendaSel.formatoListaEmpleados,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditarTrabajadores);
